"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.studentApps = exports.curriculasMocked = exports.mockCurricula = void 0;
var mockCurricula = function (partial) { return (__assign({ ariaLabel: 'Eureka Math 2', id: 'em2', imageSrc: 'em2.png', label: 'Eureka Math <sup>2</sup>', redirectionUrl: '/student/home/mywork/todo' }, partial)); };
exports.mockCurricula = mockCurricula;
exports.curriculasMocked = {
    eurekaMathSquared: (0, exports.mockCurricula)({}),
    eurekaMath: (0, exports.mockCurricula)({
        ariaLabel: 'Eureka Math',
        id: 'em',
        imageSrc: 'em.png',
        label: 'Eureka Math',
        redirectionUrl: '/assessments/student/home',
    }),
};
exports.studentApps = [
    {
        id: 'e7aad514-24ac-4b46-87be-e95023bde15f',
        curriculum: {
            name: 'Eureka Math',
            id: 'em',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EM.svg',
        },
        product: {
            name: 'Affirm',
            id: 'affirm',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/product/affirm.svg',
        },
        title: 'Eureka Math',
        thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EM.svg',
        redirectionUrl: '/assessments/student/home',
    },
    {
        id: 'f92f8a37-4017-4286-a4b4-94b973947b0a',
        curriculum: {
            name: 'Eureka Math',
            id: 'em',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EM.svg',
        },
        product: {
            name: 'Affirm',
            id: 'affirm',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/product/affirm.svg',
        },
        title: 'Eureka Math',
        thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EM.svg',
        redirectionUrl: '/assessments/student/home',
    },
    {
        id: '439822c6-69cf-4485-adc5-7a7e11742652',
        curriculum: {
            name: 'Eureka Math',
            id: 'em',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EM.svg',
        },
        product: {
            name: 'In Sync',
            id: 'in-sync',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/gm_logo_default.svg',
        },
        title: 'Eureka Math',
        thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EM.svg',
        redirectionUrl: '/assessments/student/home',
    },
    {
        id: '364af55f-299a-4e0b-8e23-9dce05f51c85',
        curriculum: {
            name: 'Eureka Math TX',
            id: 'emtx',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EX-TX.svg',
        },
        product: {
            name: 'Affirm',
            id: 'affirm',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/product/affirm.svg',
        },
        title: 'Eureka Math TX',
        thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EX-TX.svg',
        redirectionUrl: '/assessments/student/home',
    },
    {
        id: '15b98070-5351-4192-ba59-15ce76ebd893',
        curriculum: {
            name: 'Eureka Math TX',
            id: 'emtx',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EX-TX.svg',
        },
        product: {
            name: 'Affirm',
            id: 'affirm',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/product/affirm.svg',
        },
        title: 'Eureka Math TX',
        thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EX-TX.svg',
        redirectionUrl: '/assessments/student/home',
    },
    {
        id: '92a885bb-70b6-47a7-bad5-81000a4b81b8',
        curriculum: {
            name: 'Eureka Math TX',
            id: 'emtx',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EX-TX.svg',
        },
        product: {
            name: 'In Sync',
            id: 'in-sync',
            thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/gm_logo_default.svg',
        },
        title: 'Eureka Math TX',
        thumbnailUrl: 'https://cdn.digital.uat.greatminds.dev/global-nav/images/curriculum/EX-TX.svg',
        redirectionUrl: '/assessments/student/home',
    },
];
